import * as React from "react";
import { useEffect, useState } from "react";
import "./App.css";
import AlertBox from "./components/AlertBox.jsx";
import History from "./components/History.jsx";
import Intro from "./components/Intro.jsx";
import MessageInput from "./components/MessageInput";
import { loadData, checkIfWalletIsConnected, wave } from "./utils/dataUtil";
import { handleAlert } from "./utils/alertUtil";
import { ImLinkedin } from "react-icons/im";

export default function App() {
  const [currentAccount, setCurrentAccount] = useState("");
  const [message, setMessage] = useState("");
  const [data, setData] = useState([]);
  const [alertInfo, setAlertInfo] = useState({
    amessage: "",
    acolor: "#000000",
    show: false,
  });

  const connectWallet = async () => {
    try {
      const { ethereum } = window;

      if (!ethereum) {
        handleAlert("Get MetaMask!", "#0f5200", setAlertInfo);
        return;
      }

      const accounts = await ethereum.request({
        method: "eth_requestAccounts",
      });

      console.log("Connected", accounts[0]);
      setCurrentAccount(accounts[0]);
      loadData(setData, handleAlert, setAlertInfo);
    } catch (error) {
      handleAlert("Can't connect to the wallet!", "#f56c42", setAlertInfo);
      console.log(error);
    }
  };

  useEffect(() => {
    checkIfWalletIsConnected(
      setCurrentAccount,
      setData,
      handleAlert,
      setAlertInfo
    );
  }, []);

  return (
    <div className="mainc">
      <div className="info">
        <a href="https://www.linkedin.com/in/pranshujain4/">
          <span>Connect on </span>
          <ImLinkedin class="linkedin" />
        </a>
      </div>
      <div className="intro">
        <Intro />
        <MessageInput
          message={message}
          setMessage={setMessage}
          wave={wave}
          setAlertInfo={setAlertInfo}
          setData={setData}
          currentAccount={currentAccount}
          connectWallet={connectWallet}
        />
      </div>
      <AlertBox
        amessage={alertInfo.amessage}
        acolor={alertInfo.acolor}
        show={alertInfo.show}
      />

      <History data={data} />
    </div>
  );
}
